import { CSA_PRODUCT_LIST_REQUEST, CSA_PRODUCT_LIST_SUCCESS, CSA_PRODUCT_LIST_FAILURE, CSA_PRODUCT_SEARCH_VALUES
    ,PRICE_DETAILS_REQUEST
    ,PRICE_DETAILS_SUCCESS,
     PRICE_DETAILS_FAILURE,
     STORE_SOH_REQUEST
    ,STORE_SOH_SUCCESS,
     STORE_SOH_FAILURE,
     APPLICABLE_SCHEMES_REQUEST
     ,APPLICABLE_SCHEMES_SUCCESS,
      APPLICABLE_SCHEMES_FAILURE,
      SCHEMES_FAILURE,
      SCHEMES_REQUEST,
      SCHEMES_SUCCESS,
       SERIALNO_FAILURE,
      SERIALNO_REQUEST,
      SERIALNO_SUCCESS,
      RESETDBSESSION_FAILURE,
      RESETDBSESSION_SUCCESS,
      RESETDBSESSION_REQUEST

 } from "../constants/ActionTypes";

const initialState = {
    loading: false,
    csaVariants: [],
    csaProducts: [],
    priceDetails:[],
    storeSoh:[],
    applicableShemes:[],
    serialNoDetails : [],
    resetDbSession : null,
    schemes:[],
    error: null,
    success: false,
    csaSearchValue: [],
};

export default function csaReducer(state = initialState, action) {
    switch (action.type) {
        case CSA_PRODUCT_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CSA_PRODUCT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                // always replacing data
                csaProducts: action.data.product_details,
                csaVariants: action.data.variants,
                serialNoDetails:[],
                success: true,
            };
        case CSA_PRODUCT_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
            case SCHEMES_REQUEST:
                return {
                    ...state,
                    loading: true,
                };
            case SCHEMES_SUCCESS:
              
                return {
                    ...state,
                    loading: false,
                    schemes: action.data.schemes,
                    success: true,
                };
            case SCHEMES_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error: action.error,
                };
    
            case PRICE_DETAILS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PRICE_DETAILS_SUCCESS:
           
            return {
                ...state,
                loading: false,
                priceDetails: action.data.price_details,
                success: true,
            };
        case PRICE_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

            case STORE_SOH_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case STORE_SOH_SUCCESS:
           
            return {
                ...state,
                loading: false,
                storeSoh: action.data,
                success: true,
            };
        case STORE_SOH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
            case APPLICABLE_SCHEMES_REQUEST:
                return {
                    ...state,
                    loading: true,
                };
            case APPLICABLE_SCHEMES_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    applicableShemes: action.data.applicableSchemes,
                    success: true,
                };
            case APPLICABLE_SCHEMES_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error: action.error,
                };
                case SERIALNO_REQUEST:
                return {
                    ...state,
                    loading: true,
                };
            case SERIALNO_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    serialNoDetails: action.data.serialNoDetails,
                    csaProducts:[],
                    success: true,
                };
            case SERIALNO_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error: action.error,
                };
                    case RESETDBSESSION_REQUEST:
                return {
                    ...state,
                    loading: true,
                };
            case RESETDBSESSION_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    resetDbSession: action.data,
                    success: true,
                };
            case RESETDBSESSION_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error: action.error,
                };
                
        case CSA_PRODUCT_SEARCH_VALUES: 
            return {
                ...state,
                csaSearchValue: action.data,
            }
             
        default:
            return {...state};
    }
}
